<ng-container *ngIf="showMainScreen && _session">
  <div fxLayout="column" fxLayoutAlign="start" class="full-screen" class="spaceBottom">
    <div class="module-header">
      <button mat-icon-button (click)="goBack()" class="back-button">
        <mat-icon>arrow_back</mat-icon>
      </button>
    </div>
    <app-header
    (save-file)="onSaveFile()"
    (load-file)="loadNewFile()"
    [title]="_session.getToolName() + ' ' + _session.getCurrentToolVersion()"
    ></app-header>
    <!-- <div>
      <app-dialog-import-file></app-dialog-import-file>
    </div> -->
    <div *ngIf="images && images.length >= 1" id="images-from-file-container">
      <h1 class="centerTitle" i18n>Select an image to make changes</h1>
      <h2 class="centerTitle" i18n>You can then choose to keep it, publish it as OER or search for a replacement.</h2>
      <div class="progressDiv" >
        <mat-progress-bar [value]="(_session.initialImageCount-images.length)/_session.initialImageCount*100"></mat-progress-bar>
        <span i18n>You've finished {{(_session.initialImageCount-images.length)}} out of {{_session.initialImageCount}} images already.</span>
        <br/>
        <a href="#processed" (click)="viewReplacedImages(); $event.preventDefault()" *ngIf="(_session.initialImageCount-images.length) > 0" i18n>View already replaced images</a>
        </div>
        <br>
        <div class="multiSelectTop" *ngIf=" multiSelectedImages.length >= 1" >
          <div>
            <h3 i18n>{{this.multiSelectedImages.length}} Images selected</h3>
            <br/>
          </div>
            <button mat-raised-button color="primary" (click)=this.openBottomSheetActions(this.multiSelectedImages) i18n>Process all selected images simultaneously</button>
            <button style="margin-top: 10px;" mat-button (click)="this.multiSelectedImages = []" i18n>Clear selection</button>
        </div>
      <app-image-gallery
        *ngIf="images"
        [images]="images"
        [show-info]="showInfoOptions"
        (singleSelection)="openBottomSheetActions([$event])"
        [(selectedImages)]="multiSelectedImages"
        [multiSelectionEnabled]="true"
      ></app-image-gallery>
    </div>
    <div *ngIf="images && images.length < 1" class="centerText finishedText">
      <h1 *ngIf="images" class="centerTitle" i18n>Finished!</h1>
      <h3 *ngIf="images" class="centerTitle">
        <span i18n>
        There are no images left.
        </span>
        <br/>
        <span i18n>
          You can now download the converted result.
        </span>
      </h3>
      <button mat-raised-button color="primary" (click)="onSaveFile()" i18n>Download Result</button>
      <br />
      <br />
      <br />
      <button mat-raised-button color="accent" (click)="loadNewFile()" i18n>Load a new file</button>
    </div>
      <app-action-viewer *ngIf="this._session.getFileHandler()"></app-action-viewer>
    <!-- <app-feedback *ngIf="images" ></app-feedback> -->
  </div>
</ng-container>
